export const pwaForcedStandaloneCookie = 'pwaOn';
export const isPwaStandaloneCookie = 'is_pwa';
export const isPwaStandalonForced = typeof document !== 'undefined' && !!document.cookie.match(new RegExp(pwaForcedStandaloneCookie, 'i'));
export const isPwaStandalone =
    isPwaStandalonForced ||
    (typeof window !== 'undefined' &&
        (('standalone' in window.navigator && (<any>window.navigator).standalone) ||
            window.matchMedia('(display-mode: standalone)').matches));
